import type {
    ViewStyle
} from "react-native";
import {
    concentric
} from "./concentric";
import {
    getCornersStyle
} from "./corner";

export type FooterBandStyleConstantType = {
    shapeConfigs: Pick<NCoreUIKit.ShapeConfigs, "cornerShape" | "squircleRadiusScale">;
    colors: NCoreUIKit.ActivePalette["colors"];
    spaces: NCoreUIKit.ActivePalette["spaces"];
    borders: NCoreUIKit.Borders;
    surfaceBorderWidth: number;
    outerRadius: number;
    inset: number;
};

export const getFooterBandStyle = ({
    surfaceBorderWidth,
    shapeConfigs,
    outerRadius,
    borders,
    colors,
    spaces,
    inset
}: FooterBandStyleConstantType): ViewStyle => {
    const innerRadius = concentric({
        inset: surfaceBorderWidth,
        outer: outerRadius,
        role: outerRadius
    });

    return {
        ...getCornersStyle({
            corners: {
                borderEndStartRadius: innerRadius,
                borderEndEndRadius: innerRadius
            },
            shapeConfigs
        }),
        backgroundColor: colors.system.state.overlay.fill.default,
        paddingVertical: spaces.spacingSm + spaces.spacingXs,
        borderTopColor: colors.content.border.subtle,
        borderTopWidth: borders.separator,
        paddingHorizontal: inset
    };
};
